import {useTranslation} from 'react-i18next';
import {useGuestCreationContext} from 'pages/Auth/context';
import {GuestCreationModal} from 'components/GuestCreationModal';
import {StatusModalStates} from 'components/StatusModal';

const getTitle = (state?: StatusModalStates) => {
  if (state === StatusModalStates.LOADING) {
    return 'sending_guests_data';
  } else if (state === StatusModalStates.ERROR) {
    return 'error';
  } else {
    return 'guests_registered';
  }
};

export const OnboardingGuestCreationModal = () => {
  const {t} = useTranslation();
  const {
    isModalOpen,
    guestRegistrationStatus,
    successSubtitle,
    errorMessage,
    errorMessages,
    closeModalAndReset,
  } = useGuestCreationContext();

  return (
    <GuestCreationModal
      isOpen={isModalOpen}
      state={guestRegistrationStatus}
      title={t(getTitle(guestRegistrationStatus))}
      successSubtitle={successSubtitle}
      errorMessage={errorMessage}
      errorMessages={errorMessages}
      onClose={closeModalAndReset}
    />
  );
};
